import React from 'react'

export const ImageIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref): React.ReactElement => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M4 14.0996L6.37114 11.8269C6.97132 11.2517 7.92489 11.2743 8.49714 11.8773L16 19.7838"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15.1171L13.6514 13.1511C14.2509 12.4375 15.3491 12.4375 15.9486 13.1511L19 16.7838"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="4" y="4" width="16" height="16" rx="4" stroke="currentColor" strokeWidth="2" />
      </svg>
    )
  }
)

export default ImageIcon
